import { render, staticRenderFns } from "./UltimasVisualizacoes.vue?vue&type=template&id=7e2fe3c1"
import script from "./UltimasVisualizacoes.vue?vue&type=script&lang=js"
export * from "./UltimasVisualizacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports